<template>
  <div>
    <b-navbar
      toggleable="lg"
      type="dark"
      variant="dark"
      align="right"
      fixed="top"
    >
      <b-container>
        <b-navbar-brand class="text-uppercase" to="/"
          >The Geeky Helper</b-navbar-brand
        >
        <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
        <b-collapse id="nav-collapse" is-nav>
          <b-navbar-nav>
            <b-nav-item to="/#about">About Me</b-nav-item>
            <b-nav-item to="/#what-i-do">What I Do</b-nav-item>
            <!-- <b-nav-item href="/blog">Blog</b-nav-item> -->
            <b-nav-item to="/#contact">Contact</b-nav-item>
          </b-navbar-nav>
        </b-collapse>
      </b-container>
    </b-navbar>
  </div>
</template>

<script>
export default {
  name: "Navbar",
};
</script>

<style scoped>
</style>